<template>
  <div class="root">
    <div class="page-header">
      <button class="btn back-btn" @click="navigateBack">
        <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.69945 0.366117C9.18761 -0.122039 9.97887 -0.122039 10.467 0.366117C10.9552 0.854272 10.9552 1.64554 10.467 2.13369L3.01748 9.58324L10.467 17.0328C10.9552 17.5209 10.9552 18.3122 10.467 18.8004C9.97887 19.2885 9.18761 19.2885 8.69945 18.8004L0.366117 10.467C-0.122039 9.97887 -0.122039 9.1876 0.366117 8.69945L8.69945 0.366117Z" fill="black"/>
        </svg>
      </button>
      <div class="page-title">รางวัลทั้งหมด</div>
    </div>

    <div v-if="rewardsStatus === 'loading'" class="text-center my-4">Loading...</div>

    <div v-else-if="displayRewards.length > 0" class="reward-grid">
      <div v-for="it in displayRewards" :key="it.id" class="reward-item">
        <RewardCard :reward="it" @select="gotoReward" />
      </div>
    </div>

    <div v-else class="text-center my-4">Coming soon</div>
  </div>
</template>

<script>
import RewardCard from '@/components/RewardCard.vue'

export default {
  name: 'rewardsAll',
  components: {
    RewardCard,
  },
  computed: {
    rewardsData() {
      return this.$store.state.rewards.data || []
    },
    rewardsStatus() {
      return this.$store.state.rewardsStatus
    },
    displayRewards() {
      const filtered = this.rewardsData.filter((rw) => rw.categoryId !== 24)
      const normal = filtered.filter((rw) => rw.category?.title !== 'รางวัลพิเศษ')
      const special = filtered.filter((rw) => rw.category?.title === 'รางวัลพิเศษ')
      const normalSorted = normal.sort((a, b) => b.redeemPoint - a.redeemPoint)
      const specialSorted = special.sort((a, b) => b.redeemPoint - a.redeemPoint)
      return specialSorted.concat(normalSorted)
    },
  },
  methods: {
    async fetchRewards() {
      return await fetch(process.env.VUE_APP_API_URL + '/rewards', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$JWT}`,
        },
      })
    },
    async init() {
      if (this.rewardsData.length > 0) return
      this.$store.commit('SET_REWARDS_STATUS', 'loading')
      try {
        const res = await this.fetchRewards()
        if (res.status !== 200) throw new Error(`Unexpected status ${res.status}`)
        const body = await res.json()
        this.$store.commit('SET_REWARDS', body)
        this.$store.commit('SET_REWARDS_STATUS', 'ok')
      } catch (error) {
        console.log(error)
        this.$store.commit('SET_REWARDS_STATUS', 'error')
      }
    },
    gotoReward(reward_id) {
      this.$router.push({
        path: '/reward/' + reward_id,
      })
    },
    navigateBack() {
      this.$router.back()
    },
  },
  mounted() {
    this.init()
    window.loading(false)
  },
}
</script>

<style scoped>
.root {
  padding: 16px;
  background: #fff;
  min-height: 100vh;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.back-btn {
  padding: 0;
}

.page-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #000;
}

.reward-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.reward-item {
  min-width: 0;
}
</style>
